import aiVideoGenerationExtension from './AiVideoGeneration';
import exerciseExtension from './Exercise';
import quizExtension from './Quiz';
import roleplayExtension from './Roleplay';
import scormExtension from './Scorm';
import surveyExtension from './Survey';

interface GetReactExtensionsOptions {
  scormEnabled: boolean;
  isAiVideoGenerationEnabled: boolean;
  isRoleplayEnabled: boolean;
}

export const getReactExtensions = ({
  scormEnabled,
  isAiVideoGenerationEnabled,
  isRoleplayEnabled,
}: GetReactExtensionsOptions) => [
  exerciseExtension,
  quizExtension,
  surveyExtension,
  ...(scormEnabled ? [scormExtension] : []),
  ...(isAiVideoGenerationEnabled ? [aiVideoGenerationExtension] : []),
  ...(isRoleplayEnabled ? [roleplayExtension] : []),
];
